import httpClient from "./httpClient";

const profileService = {
  getChargePlanning() {
    return httpClient.get("/api/adv/profil");
  },
  getProfileTypes() {
    return httpClient.get("/api/adv/profil/types");
  },
  getCountries() {
    return httpClient.get("/api/adv/profil/countries");
  },
  getSituation() {
    return httpClient.get('/api/recruitment/candidate/marital-status');
  },
  getMyContract() {
    return httpClient.get('/api/adv/profil/lissage/info');
  },
  submitContract(data) {
    return httpClient.post('/api/adv/profil/lissage/info', data);
  },
  submitPlanning(data) {
    return httpClient.put("/api/adv/profil/planning-wishes", data);
  },
  updateInfor(data) {
    return httpClient.put("/api/adv/profil/personal-information", data);
  },
  updateAdminInfor(data) {
    return httpClient.put("/api/adv/profil/administrative-information", data);
  },
  updateTransport(data) {
    return httpClient.put("/api/adv/profil/transport", data);
  },
  updateTraining(data) {
    return httpClient.put("/api/adv/profil/training", data);
  },
  updateExp(data) {
    return httpClient.put("/api/adv/profil/experience", data);
  },
};

export default profileService;
